module.exports = __webpack_public_path__ + "img/2.4ba3e7d5.jpg";